import {
  ACTION_DOWNLOAD_AUDIT_LOG_FAILURE,
  ACTION_DOWNLOAD_AUDIT_LOG_REQUEST,
  ACTION_DOWNLOAD_AUDIT_LOG_SUCCESS,
  ACTION_GET_USER_FAILURE,
  ACTION_GET_USER_REQUEST,
  ACTION_GET_USER_SUCCESS,
  ACTION_SWITCH_ORGANIZATION_FAILURE,
  ACTION_SWITCH_ORGANIZATION_REQUEST,
  ACTION_SWITCH_ORGANIZATION_SUCCESS,
  ACTION_TOGGLE_CALL_DIALOG,
} from '@/app/module/user/definitions'
import { createReducer } from '@/app/service/util'

import defaultState from './state'

export default createReducer(defaultState, {
  [ACTION_GET_USER_REQUEST]: (state) => ({
    ...state,
    details: {
      ...state.details,
      loading: true,
      error: defaultState.details.error,
    },
  }),
  [ACTION_GET_USER_SUCCESS]: (state, { value }) => ({
    ...state,
    details: {
      loading: false,
      init: true,
      error: defaultState.details.error,
      data: value,
    },
  }),
  [ACTION_GET_USER_FAILURE]: (state, { value }) => ({
    ...state,
    details: {
      ...state.details,
      loading: false,
      data: {},
      error: value,
    },
  }),
  [ACTION_SWITCH_ORGANIZATION_REQUEST]: (state) => ({
    ...state,
    organization: {
      ...state.organization,
      loading: true,
    },
  }),
  [ACTION_SWITCH_ORGANIZATION_SUCCESS]: (state) => ({
    ...state,
    organization: {
      ...state.organization,
    },
  }),
  [ACTION_SWITCH_ORGANIZATION_FAILURE]: (state) => ({
    ...state,
    organization: {
      ...state.organization,
      loading: false,
    },
  }),
  [ACTION_DOWNLOAD_AUDIT_LOG_REQUEST]: (state) => ({
    ...state,
    auditLog: {
      loading: true,
    },
  }),
  [ACTION_DOWNLOAD_AUDIT_LOG_SUCCESS]: (state) => ({
    ...state,
    auditLog: {
      loading: false,
    },
  }),
  [ACTION_DOWNLOAD_AUDIT_LOG_FAILURE]: (state, { value }) => ({
    ...state,
    auditLog: {
      loading: false,
      error: value,
    },
  }),
  [ACTION_TOGGLE_CALL_DIALOG]: (state, { value }) => ({
    ...state,
    callDialog: {
      ...state.callDialog,
      ...value,
    },
  }),
})
